
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { ErrorsModule } from '@/store/modules/error'

@Component({
    name: 'warning'
})
export default class Warning extends Vue {

    get keys() {
        return ErrorsModule.keys
    }

    message(key: string) {
        return ErrorsModule.errors[key]
    }

    onClose(key: string) {
        ErrorsModule.SetError({ key })
    }
}
